import { render } from "./CreateRelationForm.vue?vue&type=template&id=398e2752&ts=true"
import script from "./CreateRelationForm.vue?vue&type=script&lang=ts"
export * from "./CreateRelationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__